import SwapVertIcon from "@mui/icons-material/SwapVert";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { DBTilte } from "../Mangement/modal/CloumnFilter/ExtensiveFilterContent";

interface ISearchFilterSortProps {
  onClick: (fieldName: string) => void;
  fieldName: string;
  currentSortFieldName: string;
  isAscending: boolean;
}

enum sortTypes {
  none,
  ascending,
  descending,
}

export const SearchFilterSort = (props: ISearchFilterSortProps) => {
  const [sortType, setSortType] = useState<sortTypes>(sortTypes.none);

  useEffect(() => {
    let lSortType: sortTypes = sortTypes.none;
    if (props.fieldName === props.currentSortFieldName) {
      if (props.isAscending) {
        lSortType = sortTypes.ascending;
      } else {
        lSortType = sortTypes.descending;
      }
    }
    setSortType(lSortType);
  }, [props.currentSortFieldName, props.fieldName, props.isAscending]);

  const handleClick = () => {
    props.onClick(props.fieldName);
  };
  const renderTooltipTitle = () => {
    if (props.fieldName === DBTilte.createdBy) {
      return "CreatedBy";
    }
    if (props.fieldName === DBTilte.createdOn) {
      return "CreatedOn";
    }
    if (props.fieldName === DBTilte.updatedBy) {
      return "UpdatedBy";
    }
    if (props.fieldName === DBTilte.updatedOn) {
      return "UpdatedOn";
    }
  };

  return (
    <>
      {sortType === sortTypes.none && (
        <Tooltip title={renderTooltipTitle()}>
          <SwapVertIcon
            onClick={handleClick}
            style={{ cursor: "pointer" }}
            className="column-filter-icon"
          />
        </Tooltip>
      )}

      {sortType === sortTypes.ascending && (
        <NorthIcon onClick={handleClick} style={styles.iconColor} />
      )}

      {sortType === sortTypes.descending && (
        <SouthIcon onClick={handleClick} style={styles.iconColor} />
      )}
    </>
  );
};

// Styles using standard CSS-in-JS approach
const styles = {
  iconColor: {
    fontSize: 20,
    color: "#ec6c2a",
    cursor: "pointer",
    backgroundColor: "white",
    borderRadius: "4px",
  },
};
